import { Box, Card, TextField, Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PageShell from '../components/PageShell'
import { ALLOWABLE_HOSTS } from './constants'
import Recipe from './Recipe'

const RecipeParser: FC = () => {
  const [recipeUrl, setRecipeUrl] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!recipeUrl) {
      setError('')
      return
    }
    try {
      const url = new URL(recipeUrl)
      if (!ALLOWABLE_HOSTS.includes(url.hostname)) {
        setError('Unsupported site — try Epicurious, Bon Appétit, or NYT Cooking.')
      } else {
        setError('')
      }
    } catch {
      setError('Enter a valid URL including https://')
    }
  }, [recipeUrl])

  return (
    <PageShell maxWidth='md'>
      <Typography
        component={RouterLink}
        to='/lab'
        variant='body2'
        sx={{
          display: 'inline-block',
          mb: 2,
          color: 'text.secondary',
          textDecoration: 'none',
          '&:hover': { color: 'primary.main' }
        }}
      >
        ← Back to Lab
      </Typography>
      <p className='section-eyebrow'>Lab · Utility</p>
      <h1 className='section-heading'>Recipe Parser</h1>
      <Typography className='section-lead' component='p'>
        Paste a recipe URL and get a clean, readable layout — no ads, no clutter.
        Supports Epicurious, Bon Appétit, and NY Times Cooking.
      </Typography>

      <TextField
        fullWidth
        label='Recipe URL'
        placeholder='https://cooking.nytimes.com/...'
        variant='outlined'
        value={recipeUrl}
        onChange={(e) => setRecipeUrl(e.target.value)}
        error={Boolean(error)}
        helperText={error}
        sx={{
          mb: 3,
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'background.paper'
          }
        }}
      />

      {!error && recipeUrl && (
        <Card
          elevation={0}
          sx={{
            border: '1px solid',
            borderColor: 'rgba(255,255,255,0.08)',
            overflow: 'hidden'
          }}
        >
          <Box sx={{ p: { xs: 1, sm: 2 } }}>
            <Recipe url={recipeUrl} />
          </Box>
        </Card>
      )}
    </PageShell>
  )
}

export default RecipeParser
